import Vue from 'vue';
import { defineStore } from 'pinia';

import MicroserviceApi from '@/store/api/system/microservice';
import StatusLogApi from '@/store/api/system/statusLog';

export const useMicroservicesStore = defineStore('microservices', {
    state: () => ({
        processing: {}
    }),

    actions: {
        process({ key, api, url, token, data }) {
            this.updateProcessing({ key, status: true });

            let method, config;
            switch (api.toLowerCase()) {
                case 'rest':
                    if (token) {
                        config = {
                            headers: {
                                Authorization: `Bearer ${token}`
                            }
                        };
                    }
                    method = MicroserviceApi.REST;
                    break;
            }

            if (method) return method(url, data, config);
        },

        addStatusLog(payload) {
            return StatusLogApi.create(payload);
        },

        updateProcessing({ key, status }) {
            Vue.set(this.processing, key, status);
        }
    }
});
